import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SafeValue } from '@angular/platform-browser';
import { unwrapSafeValue } from '../unwrap-safe-value';

export function isUrl(url: string | undefined): boolean {
  const urlReg = new RegExp(
    /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/,
    'gi',
  );
  return url ? urlReg.test(url) : false;
}

export function isUrlOrImage(value: string | SafeValue | undefined): boolean {
  if (value === undefined) {
    return false;
  }
  const url = unwrapSafeValue(value);
  if (url.startsWith('assets/images/')) {
    return true;
  }
  return isUrl(url);
}

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const url = control.value;
    return isUrl(url) ? null : { url: url };
  };
}
